import Box from "@mui/material/Box";

import { compareOptions, RangeQuery } from "../Tir/Tir";

const Tor = ({ active = true }) => (
	<Box sx={{ p: { xs: 2, md: 3 } }}>
		<RangeQuery
			title="TOR"
			endpoint="/uc_vs_ginesys/tor"
			facilitiesEndpoint="/uc_vs_ginesys/tor/facilities"
			facilityLabels={{ uc_vs_ginesys: "GN facility" }}
			ucFacilityLabel={{ uc_vs_ginesys: "UC facility" }}
			directions={[compareOptions[0]]}
			filePrefix="tor"
			active={active}
		/>
	</Box>
);

export default Tor;
